import Immutable from 'immutable';
import ClassFactory from 'sharedreact/utils/ClassFactory';

const Content: {
  objType: string,
  subType: string,
  value: number
} = {
  objType: 'TypedFloat',
  subType: 'Double',
  value: 0
};

class TypedFloat extends Immutable.Record(Content) {
  static fromJS (json: object): TypedFloat {
    return ClassFactory.createFromJson(json, TypedFloat);
  }

  static createFloat (value: number): TypedFloat {
    return new TypedFloat({subType: 'Float', value: value});
  }

  static createDouble (value: number): TypedFloat {
    return new TypedFloat({subType: 'Double', value: value});
  }
}

export default TypedFloat;
